import { useCallback, useRef } from 'react';
import type { ThreeColGoodsListItem } from '../types';
import type { FlatListProps } from 'react-native';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';

export const useLogDisplayGoods = (screen?: string) => {
  const goodsItemLoggedList = useRef<Array<number>>([]);

  const logDisplayGoods = useCallback<
    NonNullable<FlatListProps<ThreeColGoodsListItem>['onViewableItemsChanged']>
  >(
    ({ viewableItems }) => {
      viewableItems.forEach(({ index, isViewable, item }) => {
        if (index === null || !isViewable) {
          return;
        }

        if (item.type === 'placeholder') {
          return;
        }
        if (goodsItemLoggedList.current.includes(item.data.sno)) {
          return;
        }
        goodsItemLoggedList.current.push(item.data.sno);

        const { data } = item;

        bridge.logAnalyticsEvent({
          name: 'DISPLAY_GOODS',
          analytics: {
            ...(isNotNil(screen) && { SCREEN: screen }),
            ...data.logging.analytics,
          },
          ably_only_log: data.logging.ably_only_log,
        });

        if (isNotNil(item.data.item.ad)) {
          bridge.logAdEvent({
            action: AdAction.DISPLAY,
            ad: item.data.item.ad,
          });
        }
      });
    },
    [screen],
  );

  return { logDisplayGoods };
};
